module.exports = __webpack_public_path__ + "img/icon-area.f29fc736.svg";